module.exports = __webpack_public_path__ + "static/media/Lei-Zhang.a50bbddb.png";